import * as React from "react";
import { useEffect, useState, useCallback } from "react";
import { M_TABLE_HEADERS_ANNOUNCEMENTS } from "../constants";
import { Cell } from "@components/table/types";
import {
  Box,
  Button,
  IconButton,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { FilterType, Form, Table } from "@components";
import { useAnnouncementStore } from "../../../../../store/hooksy";
import {
  AnnouncementModel,
  AnnouncementModelForForm,
} from "@api/types/announcements";
import { getAllAnnouncements } from "@api/getAnnouncements";
import { AnnouncementDetail } from "./detail";
import { Delete as DeleteIcon } from "@material-ui/icons";
import { deleteAnnouncement } from "@api/admin/announcement";
import { alertService } from "@services";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import htmlToDraft from "html-to-draftjs";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_ANNOUNCEMENTS.TITLE },
  { data: M_TABLE_HEADERS_ANNOUNCEMENTS.DATE_POSTED },
  { data: M_TABLE_HEADERS_ANNOUNCEMENTS.POSTED_BY },
  { data: M_TABLE_HEADERS_ANNOUNCEMENTS.IS_ACTIVE },
  { data: "" },
];

export const Announcements: React.FC = () => {
  const [
    announcementHooksyStore,
    setAnnouncementHooksyStore,
  ] = useAnnouncementStore();
  const [announcementsList, setAnnouncementList] = useState<
    AnnouncementModel[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedAnnouncement, setselectedAnnouncement] = useState<
    AnnouncementModel
  >();
  const [openAnnouncement, setOpenAnnouncement] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [forDelete, SetForDelete] = useState<AnnouncementModel>();
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const form = Form.useManager<AnnouncementModelForForm>({
    id: 0,
    title: "",
    message: EditorState.createEmpty(),
    datePosted: null,
    postedBy: "",
    isActive: false,
  });

  // necessary because backend stores DateTimeObjects in UTC
  // split UTC DateTimeObject between T character
  function formatDateTimeJavaString(announcementDatePosted: any): string {
    const split = announcementDatePosted.split("T");
    return split[0] + " " + split[1];
  }

  function getDataList() {
    setIsLoading(true);
    getAllAnnouncements()
      .then((response: any) => {
        let dataList: any = response.announcements;
        dataList.forEach((announcement: any) => {
          let formattedDate = formatDateTimeJavaString(announcement.datePosted);
          announcement.datePosted = formattedDate;
        });
        setAnnouncementList(dataList);
      })
      .catch((error) => {
        console.error(`Error in fetching announcements ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
        setAnnouncementHooksyStore({ fetchList: false });
        //setGsapHooksyStore({ fetchList: false });
      });
  }

  function delAnnouncement(id: number) {
    setIsDeleting(true);
    deleteAnnouncement(id)
      .then((response: any) => {
        if (response) {
          alertService.success({ msg: "Announcement successfully deleted" });
        }
      })
      .catch((error) => {
        if (error.response) {
          alertService.danger({
            msg: "Please verify that you have the correct permissions.",
          });
        }
      })
      .then(() => {
        closeDeleteModal();
        setIsDeleting(false);
        setAnnouncementHooksyStore({ fetchList: true });
      });
  }

  function closeDeleteModal() {
    setOpenDeleteModal(false);
  }

  // function updateDataList(id: number) {
  //   if (id) {
  //     getAnnouncementById(id)
  //       .then((response: any) => {
  //         let announcementsListCopy: any = announcementsList;
  //         let updatedAnnouncement = response;
  //         let announcementsListNew: any = [];
  //         announcementsListCopy.array.forEach((a: any) => {
  //           if (updatedAnnouncement.id === a.id) {
  //             announcementsListNew = [
  //               ...announcementsListNew,
  //               {
  //                 id: updatedAnnouncement.id,
  //                 title: updatedAnnouncement.title,
  //                 message: updatedAnnouncement.message,
  //                 datePosted: updatedAnnouncement.datePosted,
  //                 postedBy: updatedAnnouncement.postedBy,
  //                 isActive: updatedAnnouncement.isActive,
  //               },
  //             ];
  //           } else {
  //             announcementsListNew = [
  //               ...announcementsListNew,
  //               {
  //                 id: a.id,
  //                 title: a.title,
  //                 message: a.message,
  //                 datePosted: a.datePosted,
  //                 postedBy: a.postedBy,
  //                 isActive: a.isActive,
  //               },
  //             ];
  //           }
  //         });
  //         setAnnouncementList(announcementsListNew);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   }
  // }

  // on page load
  useEffect(() => {
    getDataList();
  }, []);

  // upon update of hooksy item
  useEffect(() => {
    if (announcementHooksyStore.fetchList) {
      getDataList();
    }
  }, [announcementHooksyStore]);

  useEffect(() => {
    if (openAnnouncement) {
      if (selectedAnnouncement) {
        form.set(Form.target.VALUE, ["id", selectedAnnouncement.id]);
        form.set(Form.target.VALUE, ["title", selectedAnnouncement.title]);
        const blocksFromHTML = htmlToDraft(selectedAnnouncement.message);
        form.set(Form.target.VALUE, [
          "message",
          EditorState.createWithContent(
            ContentState.createFromBlockArray(
              blocksFromHTML.contentBlocks,
              blocksFromHTML.entityMap
            )
          ),
        ]);
        form.set(Form.target.VALUE, [
          "postedBy",
          selectedAnnouncement.postedBy,
        ]);
        form.set(Form.target.VALUE, [
          "datePosted",
          selectedAnnouncement.datePosted,
        ]);
        form.set(Form.target.VALUE, [
          "isActive",
          selectedAnnouncement.isActive,
        ]);
      }
    }
  }, [openAnnouncement]);

  const isShowModal = openAnnouncement ? (
    <AnnouncementDetail
      open={openAnnouncement}
      form={form}
      onCancel={() => {
        setOpenAnnouncement(false);
      }}
    />
  ) : null;

  const pageName = "Announcements";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      <Table
        data={announcementsList.map((announcement: AnnouncementModel) => ({
          cells: [
            {
              data: announcement.title,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setselectedAnnouncement(announcement);
                setOpenAnnouncement(true);
              },
            },
            {
              data: announcement.datePosted,
            },
            {
              data: announcement.postedBy,
            },
            {
              data: announcement.isActive ? "Yes" : "No",
            },
            {
              data: (
                <IconButton
                  size="small"
                  onClick={() => {
                    SetForDelete(announcement);
                    setOpenDeleteModal(true);
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              ),
            },
          ],
          data: announcement,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by Title"
        searchColumns={[M_TABLE_HEADERS_ANNOUNCEMENTS.TITLE]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_ANNOUNCEMENTS_TOOLBAR"
        loading={isLoading}
      />
      {isShowModal}
      <Dialog open={openDeleteModal}>
        <DialogContent>
          <Box>
            <Typography align="center">
              Are you sure you want to delete announcement{" "}
              {forDelete !== undefined ? forDelete?.title : null}?
            </Typography>
            <Box textAlign="center" mt={4} mb={4}>
              <Button
                onClick={closeDeleteModal}
                variant="outlined"
                color="primary"
                disabled={isDeleting}
              >
                No
              </Button>
              {forDelete !== undefined ? (
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: "20px" }}
                  disabled={isDeleting}
                  onClick={() => {
                    delAnnouncement(forDelete?.id);
                  }}
                >
                  {isDeleting ? <CircularProgress size={20} /> : "Yes"}
                </Button>
              ) : null}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};
